import { render, staticRenderFns } from "./CustomerEditModal.vue?vue&type=template&id=d881356e&scoped=true&"
import script from "./CustomerEditModal.vue?vue&type=script&lang=js&"
export * from "./CustomerEditModal.vue?vue&type=script&lang=js&"
import style1 from "./CustomerEditModal.vue?vue&type=style&index=1&id=d881356e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d881356e",
  null
  
)

export default component.exports